import {
  ACTIVITIES_WHATSAPP_GROUPS,
  DAILY_PRACTICE_CARDS,
  ZOOM_ROOM,
} from "../../content/activities";
import { t } from "../../i18n/dict";
import { langFromPath } from "../../i18n/lang";
import { Page } from "../../layout/Page";
import { Button } from "../../ui/Button";
import { Card } from "../../ui/Card";
import { Reveal } from "../../ui/Reveal";
import { Section } from "../../ui/Section";

/** The card's own CTA label - "Join on Zoom" for the two meditation cards,
 * a more specific label for the two that open a different page entirely. */
function ctaLabel(href: string, lang: "en" | "hi"): string {
  if (href === ZOOM_ROOM.href) {
    return t(lang, "joinOnZoom");
  }
  if (href === "/resources/slide-reading") {
    return "View Slides";
  }
  return t(lang, "knowMore");
}

/**
 * The old site's `/daily-practice` (and `/daily-practice-HI`): the
 * WhatsApp group button, then the four schedule cards - the two
 * meditation cards open the shared Zoom room, Knowledge Sharing opens the
 * slide-reading hub, Swarved Reading opens `/swarved`.
 */
export function DailyPracticePage() {
  const { lang } = langFromPath(window.location.pathname);

  return (
    <Page title="Daily Practice" heading="Daily Practice">
      <Section>
        <div className="flex flex-wrap gap-3">
          {ACTIVITIES_WHATSAPP_GROUPS.map((group) => (
            <Button
              key={group.href}
              href={group.href}
              external
              variant="secondary"
            >
              {group.suffix
                ? `${t(lang, "whatsappGroup")} (${group.suffix})`
                : t(lang, "whatsappGroup")}
            </Button>
          ))}
        </div>
        <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {DAILY_PRACTICE_CARDS.map((card) => (
            <Reveal key={card.title.en}>
              <Card
                eyebrow={card.eyebrow[lang]}
                title={card.title[lang]}
                cta={{
                  label: ctaLabel(card.ctaHref, lang),
                  href: card.ctaHref,
                  external: card.external,
                }}
              >
                <p>{card.weekday[lang]}</p>
                <p className="mt-1">{card.weekend[lang]}</p>
              </Card>
            </Reveal>
          ))}
        </div>
      </Section>
    </Page>
  );
}
